<script>
  import { onMount } from 'svelte';
  import { Navigation, Pagination } from 'swiper';
  import SwiperNav from '$lib/swiper/NavAlt.svelte';
  import SwiperPagination from '$lib/swiper/Pagination.svelte';
  import VacancyItem from './Item.svelte';

  export let other;
  let swiperEl, paginationEl, navPrevEl, navNextEl;

  onMount(() => {
    Object.assign(swiperEl, {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: navNextEl,
        prevEl: navPrevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      spaceBetween: 34,
      // centeredSlides: true,
      slidesPerView: 1.5,
      breakpoints: {
        1300: {
          slidesPerView: 3,
        },
        900: {
          slidesPerView: 2.5,
        },
      },
    });

    swiperEl.initialize();
  });
</script>

<section class="other">
  <p class="other__title tagline">{other.title}</p>
  <div class="other__swiper-nav">
    <SwiperNav bind:prevAlt={navPrevEl} bind:nextAlt={navNextEl} />
  </div>
  <swiper-container bind:this={swiperEl} init={false}>
    {#each other.items as item}
      <swiper-slide>
        <VacancyItem
          type={item.type}
          title={item.title}
          position={item.position}
          level={item.level}
          url={item.url}
          desc={item.desc}
        />
      </swiper-slide>
    {/each}
  </swiper-container>
  <SwiperPagination bind:element={paginationEl} />
</section>

<style lang="scss">
  .other {
    margin: 0 auto;
    position: relative;
    padding: 10rem 13.6rem 0;

    @include resp-max('m') {
      padding: 7rem 0 0;
    }

    &__title {
      color: var(--royal-light);
      text-align: center;
      margin-bottom: 3.4rem;
    }

    &__swiper-nav {
      @include resp-max('m') {
        display: none;
      }
    }
  }
</style>
